import { render, staticRenderFns } from "./ActivityDailyRankRewardConfig.vue?vue&type=template&id=4bc3b6a4&scoped=true&lang=pug&"
import script from "./ActivityDailyRankRewardConfig.vue?vue&type=script&lang=ts&"
export * from "./ActivityDailyRankRewardConfig.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityDailyRankRewardConfig.vue?vue&type=style&index=0&id=4bc3b6a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc3b6a4",
  null
  
)

export default component.exports